import { apiFetch } from './api';

export const adminService = {
    async getUsers() {
        const data = await apiFetch('/admin/users');
        return data;
    },

    async updateUserRole(userId: string, role: 'admin' | 'user') {
        const data = await apiFetch(`/admin/users/${userId}/role`, {
            method: 'PUT',
            body: JSON.stringify({ role })
        });
        return data;
    }
};
